import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { APICONSTANTS } from "../../constants/api-constants";
import { ActiviteModel, ActiviteNode } from "../../models/simple-types/activite.model";
import { GenericLibelleService } from "../basic/generic-libelle.service";
import { HostnameService } from "../basic/hostname.service";

@Injectable()
export class ActiviteService extends GenericLibelleService<ActiviteModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTEACTIVITE, hostnameService);
  }

  constructActiviteTree(activite: ActiviteModel): ActiviteNode[] {
    const tree: ActiviteNode[] = [];
    let nodeActivite: ActiviteNode = null;
    let nodeFamille: ActiviteNode = null;
    let nodeSsFamille: ActiviteNode = null;
    let nodeCategorie: ActiviteNode = null;
    nodeActivite = new ActiviteNode();
    nodeActivite.code = activite.code;
    nodeActivite.libelle = activite.libelle;
    nodeActivite.id = activite.id;
    nodeActivite.level = 1;
    nodeActivite.idParent = null;
    nodeActivite.type = "Activite";
    nodeActivite.childrens = [];
    for (const famille of (activite.familles ?? [])) {
      nodeFamille = new ActiviteNode();
      nodeFamille.code = famille.code;
      nodeFamille.libelle = famille.libelle;
      nodeFamille.id = famille.id;
      nodeFamille.level = 2;
      nodeFamille.idParent = famille.idActivite;
      nodeFamille.type = "Famille";
      nodeFamille.childrens = [];
      for (const ssFamille of (famille.ssFamilles ?? [])) {
        nodeSsFamille = new ActiviteNode();
        nodeSsFamille.code = ssFamille.code;
        nodeSsFamille.libelle = ssFamille.libelle;
        nodeSsFamille.id = ssFamille.id;
        nodeSsFamille.level = 3;
        nodeSsFamille.idParent = ssFamille.idFamille;
        nodeSsFamille.type = "SsFamille";
        nodeSsFamille.childrens = [];
        for (const categorie of (ssFamille.categories ?? [])) {
          nodeCategorie = new ActiviteNode();
          nodeCategorie.code = categorie.code;
          nodeCategorie.libelle = categorie.libelle;
          nodeCategorie.id = categorie.id;
          nodeCategorie.level = 4;
          nodeCategorie.idParent = categorie.idSsFamille;
          nodeCategorie.idPParent = ssFamille.idFamille;
          nodeCategorie.type = "Categorie";
          nodeSsFamille.childrens.push(nodeCategorie);
        }
        nodeFamille.childrens.push(nodeSsFamille);
      }
      nodeActivite.childrens.push(nodeFamille);
    }
    tree.push(nodeActivite);
    return tree;
  }
  
  delete(id: number): Observable<ActiviteModel> {
    return this.http.delete<ActiviteNode>(APICONSTANTS.URLAPI.value + this.route + 'Delete/' + id).pipe(catchError( err => this.requestCatchError(err, 'La suppression')));
  }

  requestCatchError(error, origineError): Observable<any> {
    let errorMessage = '';
    if (error.status === 400) {
      this.toastrService.error(error.error, 'Erreur client');
      errorMessage = `Error: ${error.error.message}`;
      return throwError(errorMessage);
    }
    if (error.error instanceof ErrorEvent) {
        // client-side error
        this.toastrService.error(origineError + '  a échoué.', 'Erreur client');
        errorMessage = `Error: ${error.error.message}`;
    } else {
        // server-side error
        this.toastrService.error(origineError + '  a échoué, l\'activité ne doit plus être attaché à une société pour pouvoir être supprimée.', 'Erreur');
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
